import { useDispatch, useSelector } from 'react-redux';

import { isBefore, sub } from 'date-fns';

import { sync, syncAndDownload } from 'loot-core/client/actions';

import { AsyncStorageKey, useStorage } from './useStorage';

export type Sync = {
  smartSync(forceBankSync?: boolean): Promise<void>;
};

export function useSync(): Sync {
  const dispatch = useDispatch();
  const isBillingActive = useSelector(
    state => state.auth.billingStatus.isActive,
  );
  const { getItem: getLastBankSyncDate, setItem: setLastBankSyncDate } =
    useStorage(AsyncStorageKey.LAST_BANK_SYNC_DATE);

  async function smartSync(forceBankSync?: boolean) {
    if (!isBillingActive) {
      return;
    }

    // if 4 hours have passed, do bank sync + device sync,
    // otherwise just device sync
    const offsetDate = sub(new Date(), { hours: 4 });
    const _lastBankSyncDate = await getLastBankSyncDate();
    const lastBankSyncDate = _lastBankSyncDate
      ? new Date(_lastBankSyncDate)
      : null;
    if (
      forceBankSync ||
      !lastBankSyncDate ||
      isBefore(lastBankSyncDate, offsetDate)
    ) {
      console.debug('triggering bank sync and device sync');
      await dispatch(syncAndDownload());
      await setLastBankSyncDate(new Date().toISOString());
    } else {
      console.debug('triggering device sync');
      await dispatch(sync());
    }
  }

  return { smartSync };
}
